(function() {
    'use strict';

    const TR = angular.module('TR');
    TR.directive('checkUserPrefs', checkUserPrefs);

    function checkUserPrefs(authService) {
        return {
            restrict: 'A',
            scope: '=',
            compile() {
                if (!window.TRPCONFIG.Domain2.ClearUserPrefs) { return; }
                return function postLink() {
                    const cookieName = authService.createCookieName();
                    authService.doesHttpOnlyCookieExist(cookieName);
                    authService.checkUserPreferences();
                };
            }
        };
    }
})();
